import { render, staticRenderFns } from "./messageGroup.vue?vue&type=template&id=0bcdc65a&scoped=true"
import script from "./messageGroup.vue?vue&type=script&lang=js"
export * from "./messageGroup.vue?vue&type=script&lang=js"
import style0 from "./messageGroup.vue?vue&type=style&index=0&id=0bcdc65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdc65a",
  null
  
)

export default component.exports